import { useEffect, useRef, useState } from 'react';
import furnitureImg from "@/assets/icon1.svg";
import flightsImg from "@/assets/icon2.svg";
import realestateImg from "@/assets/icon3.svg";
import smartphoneImg from "@/assets/icon4.svg";
import TopRatedHotelStays from "@/assets/icon5.svg";
import Healthandwellness from "@/assets/icon6.svg";
import car from "@/assets/icon7.svg";
import SmartTV from "@/assets/icon8.svg";
import Strings from '@/constants/strings';
import "../index.css";
import useEmblaCarousel from "embla-carousel-react";
import AutoScroll from "embla-carousel-auto-scroll";

export const WhatsComingSection = () => {
  const [flippedCard, setFlippedCard] = useState<number | null>(null);
  const [isImageHovered, setIsImageHovered] = useState(false);

  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      loop: true,
      align: "start",
      dragFree: true,
    },
    [
      AutoScroll({
        speed: 1,
        stopOnInteraction: false,
        stopOnMouseEnter: false,
      }),
    ]
  );

  useEffect(() => {
    if (!emblaApi) return;

    if (isImageHovered || flippedCard !== null) {
      emblaApi.plugins()?.autoScroll?.stop();
    } else {
      emblaApi.plugins()?.autoScroll?.play();
    }
  }, [isImageHovered, flippedCard, emblaApi]);

  const features = [
    {
      image: furnitureImg,
      label: Strings.WhatisComing.features[0].label,
      description: Strings.WhatisComing.features[0].description,
      expense: "₹75,000",
      discount: "4% ≈ ₹3,000",
      growth: "~6%* ≈ ₹4,500",
      netBenefit: "₹7,500"
    },
    {
      image: flightsImg,
      label: Strings.WhatisComing.features[1].label,
      description: Strings.WhatisComing.features[1].description,
      expense: "₹35,000",
      discount: "5% ≈ ₹1,750",
      growth: "~6%* ≈ ₹2,100",
      netBenefit: "₹3,850"
    },
    {
      image: realestateImg,
      label: Strings.WhatisComing.features[2].label,
      description: Strings.WhatisComing.features[2].description,
      expense: "₹80,000",
      discount: "4% ≈ ₹3,200",
      growth: "~6%* ≈ ₹4,800",
      netBenefit: "₹8,000"
    },
    {
      image: smartphoneImg,
      label: Strings.WhatisComing.features[3].label,
      description: Strings.WhatisComing.features[3].description,
      expense: "₹60,000",
      discount: "5% ≈ ₹3,000",
      growth: "~6%* ≈ ₹3,600",
      netBenefit: "₹6,600"
    },
    {
      image: TopRatedHotelStays,
      label: Strings.WhatisComing.features[4].label,
      description: Strings.WhatisComing.features[4].description,
      expense: "₹1,20,000",
      discount: "5% ≈ ₹6,000",
      growth: "~6%* ≈ ₹7,200",
      netBenefit: "₹13,200"
    },
    {
      image: car,
      label: Strings.WhatisComing.features[5].label,
      description: Strings.WhatisComing.features[5].description,
      expense: "₹12,00,000",
      discount: "4% ≈ ₹48,000",
      growth: "~6%* ≈ ₹72,000",
      netBenefit: "₹1,20,000"
    },
     {
      image: Healthandwellness,
      label: Strings.WhatisComing.features[6].label,
      description: Strings.WhatisComing.features[6].description,
      expense: "₹40,000",
      discount: "3% ≈ ₹1,200",
      growth: "~6%* ≈ ₹2,400",
      netBenefit: "₹3,600"
    },
    {
      image: SmartTV,
      label: Strings.WhatisComing.features[7].label,
      description: Strings.WhatisComing.features[7].description,
      expense: "₹55,000",
      discount: "4% ≈ ₹2,200",
      growth: "~6%* ≈ ₹3,300",
      netBenefit: "₹5,500"
    },
  ];

  const goldGradient = "radial-gradient(106.89% 77.57% at 50% 0%, #382C1D 0%, #1D1D21 100%)";

  const handleCardClick = (index: number) => {
    if (flippedCard === index) {
      setFlippedCard(null);
    } else {
      setFlippedCard(index);
    }
  };

  // Combined handler for both mouse and touch events
  const handleCardTouchStart = (index: number) => {
    setIsImageHovered(true);
  };

  const handleCardTouchEnd = (index: number) => {
    setIsImageHovered(false);
    // If card is flipped and touch ends, immediately unflip it
    if (flippedCard === index) {
      setFlippedCard(null);
    }
  };

  return (
    <section id="whats_coming">
      <h2 className="text-xl md:text-6xl font-bold mb-4 md:mb-2 md:w-9/12">
        <span className="block md:hidden">{Strings.WhatisComing.sectionTitle}</span>
        <span className="hidden md:block">
          {Strings.WhatisComing.sectionTitle.split(' ')[0]}<br />
          {Strings.WhatisComing.sectionTitle.split(' ').slice(1).join(' ')}
        </span>
        <div className="bg-[#DBAD71] w-[200px] h-[1px] mb-4 md:mb-10 rounded-[19px] opacity-100 md:h-[4px]"></div>
      </h2>

      <div className="embla">
        <div className="embla__viewport" ref={emblaRef}>
          <div className="embla__container flex gap-10">
            {features.map((feature, index) => (
              <div
                key={index}
                className="embla__slide px-2 md:px-2 w-[200px] md:w-[292px] text-center mt-2"
              >
                <div
                  className={`flip-card h-[200px] md:h-64 rounded-xl cursor-pointer mb-4 ${flippedCard === index ? "flipped" : ""
                    }`}
                  onClick={() => handleCardClick(index)}
                  // For desktop/mouse devices
                  onMouseEnter={() => setIsImageHovered(true)}
                  onMouseLeave={() => {
                    setIsImageHovered(false);
                    if (flippedCard === index) {
                      setFlippedCard(null);
                    }
                  }}
                  // For mobile/touch devices
                  onTouchStart={() => handleCardTouchStart(index)}
                  onTouchEnd={() => handleCardTouchEnd(index)}
                >
                  <div className="flip-card-inner">
                    {/* Front side - Image only */}
                    <div className="flip-card-front">
                      <div className="flex items-center justify-center h-full p-4 md:p-6 group">
                        <img
                          src={feature.image}
                          alt={feature.label}
                          className="object-contain w-full h-full transition-transform duration-300 ease-out group-hover:-translate-y-4 group-hover:scale-110"
                        />
                      </div>
                    </div>

                    {/* Back side - Gradient with savings info */}
                    <div className="flip-card-back">
                      <div
                        className="h-full p-4 md:p-6 rounded-2xl text-white"
                        style={{
                          background: goldGradient,
                        }}
                      >
                        <div className="h-full flex flex-col">
                          <div className="flex-1 flex flex-col justify-start">
                            <div className="space-y-1 md:space-y-2 text-left">
                              <div className='font-medium text-xs md:text-sm text-[#FFFFFF99]'>
                                Cost: {feature.expense}
                              </div>
                              <div className='font-medium text-xs md:text-sm text-[#FFFFFF99]'>
                                Instant discount: {feature.discount}
                              </div>
                              <div className='font-medium text-xs md:text-sm text-[#FFFFFF99]'>
                                MF growth {feature.growth}
                              </div>
                              <div className="font-bold text-sm md:text-xl pt-2 md:pt-3">
                                Net benefit: {feature.netBenefit}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <h3 className="text-xs md:text-2xl font-semibold text-white mt-2">
                  {feature.label}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatsComingSection;